import { StepContent } from '@components/StepElements';
import { useQueryParams } from '@partful/shared/lib/hooks/useQueryParams';
import { useTenant } from '@providers/Tenant';
import { PartsCategoriesInteractiveTable } from './interactive-table/PartsCategoriesInteractiveTable';
import { PartsCategoriesSpreadsheet } from './PartsCategoriesSpreadsheet';

export function PartsCategoriesTabs() {
  const { accountId } = useTenant();
  const { configurationPID, tab } = useQueryParams();

  return (
    <StepContent>
      {tab === 'interactive' ? (
        /* istanbul ignore next */ <PartsCategoriesInteractiveTable configurationPID={configurationPID} />
      ) : (
        <PartsCategoriesSpreadsheet accountId={accountId} configurationPID={configurationPID} />
      )}
    </StepContent>
  );
}
